import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import HR from '../elements/HR';
import { jsx as _jsx } from "react/jsx-runtime";
const getClasses = (className = UIDropdownDivider.defaultProps.className) => classNames('private-dropdown-divider', className);
export default function UIDropdownDivider(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(HR, Object.assign({
    distance: "xs"
  }, rest, {
    className: getClasses(className)
  }));
}
UIDropdownDivider.displayName = 'UIDropdownDivider';
UIDropdownDivider.defaultProps = {
  className: ''
};